import ClipLoader from "react-spinners/ScaleLoader";

export default function InfiniteLoader(props) {
	return (
		<div
			
		>
			<ClipLoader
				color={props.color}
				loading={props.loading}
				size={props.size}
				aria-label="Loading Spinner"
				data-testid="loader"
				style={{ marginLeft: "50%" }}
			/>
		</div>
	);
}
